import React from 'react';

const CAPABILITIES = [
  {
    title: 'Product Strategy & Discovery',
    description:
      'We start by understanding the problem. Through structured discovery, research, and planning, we shape a clear product strategy that aligns technology with your business goals.',
  },
  {
    title: 'Software & Platform Development',
    description:
      'We design and build reliable software and platforms, engineered for how your business actually operates and maintained for the long run.',
  },
  {
    title: 'UI/UX Design',
    description:
      'We craft intuitive, accessible interfaces grounded in real user behaviour, so the tools we build are easy to use and a pleasure to work with.',
  },
  {
    title: 'Quality Assurance & Testing',
    description:
      'We test thoroughly at every stage, catching issues before they reach your users and making sure every release is dependable.',
  },
  {
    title: 'Digital Transformation',
    description:
      'We help organisations modernise their operations, adopt the right technology, and make lasting changes that improve how they work.',
  },
  {
    title: 'Project Delivery & Support',
    description:
      'We manage projects methodically and stay engaged after launch, providing the support needed to keep your solutions running smoothly.',
  },
];

const OurCapabilities: React.FC = () => {
  return (
    <section className="bg-[#F8FAFE] py-20">
      <div className="layout-container max-w-[1360px] mx-auto px-5 flex flex-col items-center">
        <div className="flex flex-col items-center gap-5 w-full max-w-[820px] mb-14">
          <div className="px-3 py-1 rounded-full border border-[#B8B8B8] flex items-center justify-center gap-2">
            <span className="text-[#919191] text-[10px] font-description font-normal">Our Expertise</span>
          </div>

          <div className="flex flex-col items-center gap-3 w-full text-center">
            <h2 className="w-full text-center max-w-[640px] leading-[1.1]">
              <span className="text-[#212121] text-[32px] md:text-[40px] font-title font-medium">What we </span>
              <span className="text-[#919191] text-[32px] md:text-[40px] font-title font-medium">bring to every project</span>
            </h2>
            <p className="w-full text-center text-[#919191] text-[13px] md:text-[14px] font-description font-light max-w-[740px] leading-[1.55]">
              Our work brings together practical expertise across product strategy, software development, user experience, quality assurance and digital transformation. We assemble the right capabilities around each project to help organisations solve real operational challenges and deliver reliable digital solutions.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 w-full">
          {CAPABILITIES.map((capability) => (
            <div
              key={capability.title}
              className="bg-white rounded-[16px] border border-[#E4E4E4] p-6 md:p-7 flex flex-col gap-3"
            >
              <h3 className="font-title text-[20px] md:text-[22px] font-medium leading-tight text-[#212121]">
                {capability.title}
              </h3>
              <p className="font-description text-[13px] md:text-[14px] font-light leading-[1.55] text-[#919191]">
                {capability.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default OurCapabilities;
